module.exports = __webpack_public_path__ + "static/media/IMG_4236.9dc545dc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/pokoje/IMG_4236.JPG
// module id = 94
// module chunks = 0